export const appLanguages = [
  'fr'
]

export interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}
export const FilterRapport = {
  attestation: true,
  badge: true,
}

export const languages = [
  {
    lang: 'fr',
    name: 'Français',
    flag: './assets/media/flags/france.svg',
  },
  {
    lang: 'de',
    name: 'Allemand',
    flag: './assets/media/flags/germany.svg',
  },
  {
    lang: 'en',
    name: 'Anglais',
    flag: './assets/media/flags/united-kingdom.svg',
  },
  {
    lang: 'it',
    name: 'Italien',
    flag: './assets/media/flags/italy.svg',
  },
];
export  const PlatformeLangs = {
  langs: [
    {
      code: 'fr-ch',
      name: 'fr',
      fullName: 'Français',
      flag: './assets/media/flags/france.svg',
    },
    {
      code: 'de-ch',
      name: 'de',
      fullName: 'Allemand',
      flag: './assets/media/flags/germany.svg',
    },  {
      code: 'en-ch',
      name: 'en',
      fullName: 'Anglais',
      flag: './assets/media/flags/united-kingdom.svg',
    },
    {
      code: 'it-ch',
      name: 'it',
      fullName: 'Italien',
      flag: './assets/media/flags/italy.svg',
    }
  ],
  default: 'fr'
};
export const EventActionsCustom = []
export const Platformetitle = 'SWISS WINE' ;


// export const allowedViewTypes = [
//   'formation'
//   // 'calendar'
// ];
// export const moduleViews: { [key: string]: any } = {
//   'calendar': [
//     {
//       id: 'card1',
//       template: 'calendar-card1',
//       placeholder: 'assets/images/formation-card1.png',
//     }
//   ],
//   'formation': [
//     {
//       id: 'card1',
//       template: 'catalogue-card1',
//       placeholder: 'assets/images/catalogue-card1.png',
//     },
//     {
//       id: 'card2',
//       template: 'formation-card1',
//       placeholder: 'assets/images/formation-card1.png',
//     },
//     {
//       id: 'sequence',
//       template: 'sequence-card1',
//       placeholder: 'assets/images/vue-sequence-card.png',
//     }
//   ]
// }

export const customLayout = {
  OFAG: {
    'fr': '/assets/img/OFAG-logo-fr.png',
    'en': '/assets/img/OFAG-logo-en.png',
    'de': '/assets/img/OFAG-logo-de.png',
    'it': '/assets/img/OFAG-logo-it.png'
  }
}
export const creatorOptionsCLient = {
  showLogicTab: true,
  isAutoSave: false,
  showDesignerTab: true,
  showTestSurveyTab: true,
  showTranslationTab: true,
  showJSONEditorTab: true,
  showThemeTab: false,
};
